import { memo, useEffect, useState } from "react";
import "./ImageComponent.css";

const ImageComponent = ({
  src,
  onClick,
  compClassName,
  img_width,
  img_height,
  loader_width,
  loader_height,
  border,
  borderRadius,
  boxShadow,
  trending,
  fallbackSrc,
  alt = "",
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [imageSrc, setImageSrc] = useState(src || fallbackSrc || "");

  useEffect(() => {
    if (!src) {
      setImageSrc(fallbackSrc || "");
      setIsLoading(false);
      return;
    }

    let isMounted = true;
    setIsLoading(true);

    const imageToLoad = new Image();

    imageToLoad.onload = () => {
      if (isMounted) {
        setImageSrc(src);
        setIsLoading(false);
      }
    };

    imageToLoad.onerror = () => {
      if (isMounted) {
        setImageSrc(fallbackSrc || src);
        setIsLoading(false);
      }
    };

    imageToLoad.src = src;

    // Check if the image was already cached/completed synchronously
    if (imageToLoad.complete && imageToLoad.naturalWidth > 0) {
      setImageSrc(src);
      setIsLoading(false);
    }

    return () => {
      isMounted = false;
    };
  }, [src, fallbackSrc]);

  return (
    <>
      {isLoading && (
        <div
          className={`mr-image-container ${compClassName || ""} ${isLoading ? "d-block" : "d-none"}`}
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            height: loader_height || img_height,
            width: loader_width || img_width,
          }}
        >
          <div
            className={`mr-image-loader-layer ${
              compClassName?.includes("rounded-circle")
                ? "mr-image-loader-layer--circular"
                : ""
            }`}
          >
            <span
              className={`mr-image-spinner ${
                compClassName?.includes("rounded-circle")
                  ? "mr-image-spinner--sm"
                  : ""
              }`}
              aria-hidden="true"
            />
          </div>
        </div>
      )}
      {imageSrc && (
        <img
          src={imageSrc}
          onClick={onClick}
          className={`${compClassName || ""} ${isLoading ? "d-none" : "d-block"}`}
          style={{
            border: border,
            boxShadow: boxShadow,
            maxWidth: "100%",
            width: trending ? img_width : (img_width || "100%"),
            height: img_height || "100%",
            borderRadius: borderRadius,
            objectFit: compClassName?.includes("contain") ? "contain" : "cover",
          }}
          alt={alt}
          loading="eager"
          width={img_width}
          height={img_height}
          onLoad={() => {
            setIsLoading(false);
          }}
          onError={(e) => {
            setIsLoading(false);
            if (fallbackSrc && e.target.src !== fallbackSrc) {
              e.target.src = fallbackSrc;
            }
          }}
        />
      )}
    </>
  );
};

export default memo(ImageComponent);
